<script setup>
import { reactive, ref, onMounted, computed } from "vue";
import { apiQuery } from "@/api/j24api";

const loading = ref(false);
const addNew = ref(false);
const editGroup = ref(false);
const editCustomerGroupRecord = reactive({
  _id: "",
  name: "",
  deleted: false,
  members: [],
});

const customers = reactive([]);
const customerGroups = reactive([]);

onMounted(() => {
  getData();
});

async function getData() {
  loading.value = true;
  customers.length = 0;
  customerGroups.length = 0;
  let promises = [];
  promises.push(
    apiQuery("J24Auth", "customers", { apiAction: "get" }),
    apiQuery("J24Auth", "customers", { apiAction: "getCustomerGroups" })
  );
  try {
    const results = await Promise.all(promises);
    customers.push(...results[0]);
    customerGroups.push(...results[1]);
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    loading.value = false;
  }
}

let allGroups = computed(() => {
  return customerGroups.map((group) => {
    return {
      ...group,
      membersCount: group.members ? group.members.length : 0,
    };
  });
});

const headers = [
  { title: "Group Name", key: "name", sortable: true },
  { title: "Members", key: "membersCount", sortable: false },
];

async function saveGroup() {
  loading.value = true;
  try {
    if (editCustomerGroupRecord._id) {
      await apiQuery("J24Auth", "customers", {
        apiAction: "updateCustomerGroup",
        ...editCustomerGroupRecord,
      });
    } else {
      delete editCustomerGroupRecord._id;
      await apiQuery("J24Auth", "customers", {
        apiAction: "addCustomerGroup",
        ...editCustomerGroupRecord,
      });
    }
    editGroup.value = false;
    addNew.value = false;
    editCustomerGroupRecord.name = "";
    editCustomerGroupRecord.members = [];
  } catch (error) {
    console.log(error);
  }
  getData();
}
</script>

<template>
  <h1>Customer Groups</h1>

  <template v-if="!addNew && !editGroup">
    <v-data-table
      :headers="headers"
      :items="allGroups"
      :loading="loading"
      item-key="_id"
      @click:row="
        (e, row) => {
          editCustomerGroupRecord._id = row.item._id;
          editCustomerGroupRecord.name = row.item.name;
          editCustomerGroupRecord.members = [...row.item.members];
          editGroup = true;
        }
      "
    ></v-data-table>
    <v-btn @click="addNew = true" class="mb-4" color="primary"
      >Add New Group</v-btn
    >
  </template>
  <template v-if="addNew || editGroup">
    <v-form>
      <v-text-field
        v-model="editCustomerGroupRecord.name"
        label="Group Name"
        required
      ></v-text-field>
      <v-select
        v-model="editCustomerGroupRecord.members"
        :items="customers"
        item-title="name"
        item-value="_id"
        label="Members"
        multiple
        required
      ></v-select>
      <v-btn @click="saveGroup" color="primary" :loading="loading"
        >Save Group</v-btn
      >
      <v-btn
        class="ml-2"
        @click="
          addNew = false;
          editGroup = false;
        "
        >Cancel</v-btn
      >
    </v-form>
  </template>
</template>
